import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function FirewallBasics() {
    return (
        <div className={globalStyles.article}>
            <h1>Firewall basics: ufw &amp; iptables</h1>

            <p><b>ufw</b> (Uncomplicated Firewall) is a friendly front-end over <b>iptables</b>, used by default
                on Ubuntu/Debian. Use it unless you already have raw iptables rules to maintain.</p>

            <h3>ufw</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> ufw status verbose <i># check state and rules</i><br/>
    <b>root@host:~#</b> ufw allow 22/tcp <i># allow SSH by port</i><br/>
    <b>root@host:~#</b> ufw allow OpenSSH <i># or by registered app profile</i><br/>
    <b>root@host:~#</b> ufw allow from 10.0.0.0/24 to any port 5432 <i># restrict to a subnet</i><br/>
    <b>root@host:~#</b> ufw deny 23/tcp <i># block telnet</i><br/>
    <b>root@host:~#</b> ufw delete allow 22/tcp <i># remove a rule</i><br/>
    <b>root@host:~#</b> ufw enable <i># turn the firewall on</i><br/>
            </pre>

            <p>Enable SSH access <b>before</b> running <code>ufw enable</code> on a remote box, otherwise you'll
                lock yourself out.</p>

            <h3>iptables</h3>
            <p>iptables filters packets through chains (<b>INPUT</b>, <b>OUTPUT</b>, <b>FORWARD</b>) evaluated in
                order, top to bottom, with a default policy applied if nothing matches.</p>

            <pre className={globalStyles.code}>
    <b>root@host:~#</b> iptables -L -n -v <i># list current rules</i><br/>
    <b>root@host:~#</b> iptables -A INPUT -p tcp --dport 22 -j ACCEPT <i># allow SSH</i><br/>
    <b>root@host:~#</b> iptables -A INPUT -m state --state ESTABLISHED,RELATED -j ACCEPT<br/>
    <b>root@host:~#</b> iptables -P INPUT DROP <i># default-deny everything else</i><br/>
            </pre>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Common targets</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>ACCEPT</b></td>
                        <td>Let the packet through</td>
                    </tr>
                    <tr>
                        <td><b>DROP</b></td>
                        <td>Silently discard it</td>
                    </tr>
                    <tr>
                        <td><b>REJECT</b></td>
                        <td>Discard it and tell the sender (ICMP unreachable)</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p>iptables rules don't survive a reboot on their own — persist them with the distro's helper:</p>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> iptables-save {'>'} /etc/iptables/rules.v4 <i># Debian/Ubuntu, needs iptables-persistent</i><br/>
    <b>root@host:~#</b> iptables-restore {'<'} /etc/iptables/rules.v4<br/>
            </pre>
        </div>
    )
}
